import React from 'react';
import {map} from 'lodash';
import StackedBarChart from '../stacked-bar-chart';
import Card from 'src/components/cards/card';
import CollapsibleTeaserSection from 'shared/components/collapsible-teaser-section';
import MiniInfoCardContainer from 'shared/components/college-profile/mini-info-card-container';
import MiniInfoCard from 'shared/components/college-profile/mini-info-card';
import {withCommas} from 'shared/utils';

interface Props {
  college: {
    totalUndergraduates: number;
    studentFacultyRatio: number;
    percentLivingOnCampus: number;
    genderDiversity: {name: string; percent: number}[];
    ethnicDiversity: {name: string; percent: number}[];
  };
}

const AboutStudents = ({college}: Props) => {
  const formatValue = (value) => `${value}%`;

  const formatGroups = (groups) =>
    map(groups, (group) => ({name: group.name, value: group.percent}));

  const {
    totalUndergraduates,
    studentFacultyRatio,
    percentLivingOnCampus,
    genderDiversity,
    ethnicDiversity,
  } = college;

  const bodyComponentProps = {
    caption: 'Student Diversity',
    groups: formatGroups(ethnicDiversity),
    formatValue: formatValue,
  };
  const isCollapsingDisabled = StackedBarChart.isEmptyWithProps(bodyComponentProps);
  const modifierClass = isCollapsingDisabled ? '' : 'zero-bottom-padding';

  return (
    <Card className={modifierClass}>
      <CollapsibleTeaserSection
        title="Students"
        trackIdentifier="college-listing-about-students"
        className="college-profile-card-about-content"
        isCollapsingDisabled={isCollapsingDisabled}
      >
        <CollapsibleTeaserSection.Teaser>
          <MiniInfoCardContainer>
            <MiniInfoCard
              iconType="users"
              label="Total Undergrads"
              value={totalUndergraduates ? withCommas(totalUndergraduates) : undefined}
            />
            <MiniInfoCard
              iconType="user"
              label="Student to Faculty Ratio"
              value={studentFacultyRatio ? `${studentFacultyRatio}:1` : undefined}
            />
            <MiniInfoCard
              iconType="university"
              label="Living On Campus"
              value={percentLivingOnCampus ? `${percentLivingOnCampus}%` : undefined}
            />
          </MiniInfoCardContainer>
          <StackedBarChart
            caption="Gender Balance"
            groups={formatGroups(genderDiversity)}
            formatValue={formatValue}
          />
        </CollapsibleTeaserSection.Teaser>
        <CollapsibleTeaserSection.Body>
          <StackedBarChart {...bodyComponentProps} />
        </CollapsibleTeaserSection.Body>
      </CollapsibleTeaserSection>
    </Card>
  );
};

export default AboutStudents;
